// Service page content for Working Holiday visas (Subclasses 417 and 462).
// Sourced from docs/research/australian-visa-pathways.md §7.
// COMPLIANCE: we prepare and coordinate; a registered migration agent advises,
// confirms eligibility, and lodges. No guarantees; honest that WH time rarely
// counts as skilled experience; no unverified figures stated as fact.

const workingHoliday = {
  groupSlug: "visitor-working-holiday",
  slug: "working-holiday",
  title: "Working Holiday Visas (417/462)",
  eyebrow: "Visitor & Working Holiday",
  intro:
    "Working holiday visas let young people from eligible countries travel and work in Australia for up to a year, with the chance to extend through specified work. The Subclass 417 and the Subclass 462 cover different groups of countries, with slightly different rules.",

  chips: [
    { label: "Visa type", value: "Temporary, work and travel" },
    { label: "Subclasses", value: "417 and 462" },
    { label: "Age", value: "Generally 18 to 30 (35 for some)" },
    { label: "Extensions", value: "Via specified work" },
  ],

  whoFor: [
    "Young travellers from eligible countries who want to work and holiday in Australia.",
    "People wanting to extend a working holiday into a second or third year.",
    "Those exploring Australia before considering study or skilled pathways.",
  ],

  essentials: [
    {
      title: "An eligible passport",
      detail:
        "The 417 covers one group of countries (such as the UK, Ireland, and Canada) and the 462 covers another (such as the USA, China, and India). Your passport decides which applies.",
    },
    {
      title: "Within the age range",
      detail:
        "Generally you must be 18 to 30 when you apply, raised to 35 for some countries.",
    },
    {
      title: "Education and English for the 462",
      detail:
        "The 462 generally requires some tertiary education and functional English, and some nationalities need a government letter of support.",
    },
    {
      title: "Specified work for extensions",
      detail:
        "A second or third year generally requires a period of specified work, often regional, during the previous visa. Some arrangements, such as the UK, are now exempt.",
    },
    {
      title: "Funds for your stay",
      detail:
        "You should show enough funds to support yourself when you arrive.",
    },
    {
      title: "Health and character",
      detail: "Standard health and character requirements apply.",
    },
  ],

  process: [
    {
      title: "Get your details together",
      detail:
        "We take your passport, age, and circumstances so a registered migration agent can confirm the subclass and that you meet the rules.",
    },
    {
      title: "Prepare your application",
      detail:
        "We help you assemble funds evidence and any education, English, or government-support documents needed.",
    },
    {
      title: "Lodge the application",
      detail:
        "We build a complete, ready-to-lodge file, and a registered migration agent lodges it and manages correspondence with the Department.",
    },
    {
      title: "Plan an extension",
      detail:
        "If you want a second or third year, we organise the evidence of specified work, and a registered migration agent confirms the requirements.",
    },
    {
      title: "Consider what comes next",
      detail:
        "If you decide to stay longer term, we match you with a registered migration agent who can talk through study, skilled, or sponsored options.",
    },
  ],

  faqs: [
    {
      q: "What is the difference between the 417 and 462?",
      a: "They cover different groups of countries. The 417 is for passport holders of one set of countries, the 462 for another, and the 462 generally has extra education and English requirements. Your passport determines which one you can apply for.",
    },
    {
      q: "How do I get a second or third year?",
      a: "Usually by completing a period of specified work, often in regional Australia, during your previous visa. Some arrangements, such as the UK, are now exempt from this. A registered migration agent confirms the current rule for your nationality, and we organise the evidence.",
    },
    {
      q: "Does working holiday time count toward a skilled visa?",
      a: "Generally no. Working holiday work usually does not count as skilled work experience for points unless it was in your nominated skilled occupation and is properly evidenced. We are honest about this so you do not count on it.",
    },
    {
      q: "Can a working holiday lead to permanent residence?",
      a: "Not directly. It is temporary. Some people move on to study, skilled, or employer-sponsored visas afterward. If you decide to stay, we match you with a registered migration agent who can advise on those.",
    },
  ],

  related: ["visitor-600", "student-500", "skilled-independent-189"],

  lastVerified: "13 July 2026",
};

export default workingHoliday;
